import { FormStore, GlobalStore } from '@roc/feature-app-core';
import { action, makeObservable } from 'mobx';

const uwHudForm = {
  fields: {
    salesPrice: {
      value: '',
      error: null,
      rule: ''
    },
    settlementDate: {
      value: '',
      error: null,
      rule: 'required',
      message: 'Settlement date is required.',
    },
    sellerName: {
      value: '',
      error: null,
      rule: '',
    },
    wholesalerName: {
      value: '',
      error: null,
      rule: '',
    },
    wholesaleFee: {
      value: '',
      error: null,
      rule: '',
    },
    sellerCredit: {
      value: '',
      error: null,
      rule: '',
    },
    payoffAmount: {
      value: '',
      error: null,
      rule: '',
    }
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class UwHudFormStore extends FormStore {
  constructor(globalStore: GlobalStore) {
    super({ ...uwHudForm }, globalStore);
    makeObservable(this, {
      load: action,
    });
  }

  load(data: Record<string, any>) {
    // payoffAmount is conditionally absent on uiDataContent rows written before
    // this branch shipped. Default it explicitly so an absent key resets to its
    // default instead of retaining the previous document's value
    // (FormStore.loadForm only assigns keys present in data and never clears
    // first). lender/loanAmount are no longer editable here, but remain in the
    // stored uiDataContent - mergeUiData only overlays the keys we send back,
    // so dropping them from the form leaves the extracted values intact for the
    // read-only comparison table.
    this.loadForm({ payoffAmount: '', ...data });
  }
}
